<template>
  <div class="faqCollapsible">
    <button
      :aria-controls="faqEntryId"
      :aria-expanded="isExpanded"
      class="btn-unstyled titleWrapper"
      @click="isExpanded = !isExpanded"
    >
      <img
        alt="chevron icon"
        class="chevronArrow"
        :src="props.hasWhiteArrow ? 'static/images/icons/Chevron.svg' : 'static/images/icons/chevron-dark.svg'"
      />
      <slot name="title" />
    </button>
    <SmoothReflow
      :options="{
        transition: 'height 200ms',
      }"
    >
      <div v-show="isExpanded" :id="faqEntryId" class="contentWrapper">
        <slot name="content" />
      </div>
    </SmoothReflow>
  </div>
</template>

<script setup>
import uuid from 'uuid/v4'
import { ref } from 'vue'

import SmoothReflow from 'components/reused-components/smooth-reflow/SmoothReflow'
import { bool } from 'vue-types'

const faqEntryId = uuid()
const isExpanded = ref(false)

const props = defineProps({
  hasWhiteArrow: bool().def(false),
})
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/bootstrap_variables';

.faqCollapsible {
  width: 100%;

  .titleWrapper {
    display: flex;
    align-items: baseline;
    cursor: pointer;
    user-select: none;

    .chevronArrow {
      padding: 6px;
      margin-right: 16px;
      color: $color-dark;
      transition: transform $transition-duration;
      transform: rotate(-90deg);
    }

    &[aria-expanded] .chevronArrow {
      transform: rotate(0);
    }
  }

  .contentWrapper {
    margin-top: 16px;
    margin-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// FaqCollapsible.vue